import React, { useEffect, useRef, useState } from 'react';
import L from "leaflet";
import axios from "axios";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "react-leaflet-markercluster/dist/styles.min.css";
import { MapContainer, TileLayer, GeoJSON, WMSTileLayer, Marker, Circle, useMapEvents } from "react-leaflet";
import { predicted_geoserver_layers } from '../utils/Predicted_Layers';
import { WMS_URL } from '../utils/GeoServer';
import { mapTypes } from '../utils/MapTypes';

function MapInterface({ layers, predictedLayers, heatmaps, mapType, containerStyle, onMapClick, marker, bufferRadiusMeters, bounds, center, zoom }) {
  const mapRef = useRef(null);
  const defaultCenter = [31.96223794543772, 77.22222519453342];
  const defaultZoom = 8;
console.log("adding circle....",bufferRadiusMeters,marker)
    useEffect(() => {
        if (mapRef.current) {
            mapRef.current.invalidateSize();
        }
    }, []);
    useEffect(() => {
      if (mapRef.current && marker) {
        try {
          mapRef.current.setView([marker.lat, marker.lng], 9);
        } catch (e) {
          console.warn('Center to marker failed:', e);
        }
      }
    }, [marker]);
    console.log("predicted layer",heatmaps)

    useEffect(() => {
      if (!mapRef.current) return;
      const map = mapRef.current;
      try {
        if (bounds && bounds.length === 2) {
          map.fitBounds(bounds, { padding: [20, 20] });
        } else if (center && center.length === 2) {
          map.setView(center, zoom || defaultZoom);
        }
      } catch (e) {
        console.warn('Map fit error:', e);
      }
    }, [bounds, center, zoom]);

    const handleTileError = (error) => {
      console.error("WMS Tile Layer Error:", error);
    };
  
    const handleTileLoadStart = (event) => {
      console.log("WMS Tile Layer Load Start:", event);
    };
  
    const handleTileLoadEnd = (event) => {
      console.log("WMS Tile Layer Load End:", event);
    };
    const onBlockEachFeature = (feature, layer) => {
      console.log("extracting block layer",feature?.properties)
      if (feature.properties && feature.properties.block_name) {
        const popupContent = `<div>
        <p style="margin-bottom:-5px"> <strong>Location Details</strong></p>
         <p style="margin-bottom:-15px">
         <strong>State Name:</strong> ${feature.properties.state_name}</p>
         <p>
        <p style="margin-bottom:-15px">
         <strong>District Name:</strong> ${feature.properties.district_n}</p>
         <p>
        <strong>Block Name:</strong> ${feature.properties.block_name}</p></div>`;
        layer.bindPopup(popupContent);
      }
    };
    const outerStyle = containerStyle || { height: "100vh", width: "100%", border: "1px solid #2b4f2f" };

    function ClickHandler() {
      useMapEvents({
        click(e) {
          if (onMapClick) {
            onMapClick(e.latlng);
          }
        }
      });
      return null;
    }
    return (
      <div style={outerStyle}>
            <MapContainer
              whenCreated={(m) => { mapRef.current = m; }}
              center={center || defaultCenter}
              zoom={zoom || defaultZoom}
              style={{ height: "100%", width: "100%" }}
            >
                <ClickHandler />
                <TileLayer
 attribution={`&copy; <a href="#">${mapTypes[mapType]?.ref_name}</a> contributors`}
                    url={mapTypes[mapType]?.url}
                />
                {marker && (
                  <>
                    <Marker position={[marker.lat, marker.lng]} />
                    {bufferRadiusMeters && (
                      <Circle
                        center={[marker.lat, marker.lng]}
                        radius={bufferRadiusMeters=3400}
                        pathOptions={{
                          color: 'red',
                          weight: 3,
                          opacity: 1,
                          stroke: true,
                          fill: false,
                          dashArray: '6,4'
                        }}
                      />
                    )}
                  </>
                )}
                {layers.map(layer => (
                    <GeoJSON
                        key={layer.block_name}
                        onEachFeature={onBlockEachFeature}
                        data={layer.data}
                        style={{ color: "#ff7800", weight: 1 }}
                    />
                ))}
                 {predictedLayers.map((layer) => {
  return (
    <WMSTileLayer
      key={layer.id}
      url={WMS_URL}
      layers={layer.id}
      format="image/png"
      transparent={true}
      version="1.1.1"
      opacity={0.5}
      crs={L.CRS.EPSG3857}
params={{
  CRS: "EPSG:3857",
  ...(layer.wmsParams || {})
}}
      eventHandlers={{
        tileerror: handleTileError,
        tileloadstart: handleTileLoadStart,
        tileload: handleTileLoadEnd,
      }}
    />
  );
})} 
                   
            </MapContainer>
        </div>
    );
}

export default MapInterface;
